/* import __COLOCATED_TEMPLATE__ from './add-credit-modal-confirm.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { all, dropTask } from 'ember-concurrency';
import { COMPANY_PROFILE_COMPONENT } from 'sh-www/components/company-profile/company-profile';
import { BUTTON_TYPES } from 'sh-www/constants/lsg';
import { showNextModal, closeModal } from 'sh-www/utils/modal-controls';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import CheckSweepIcon from 'sh-www/components/icons/check-sweep';

const CLASS_NAME = 'SH-c-reports-add-credit-modal';

class ReportsAddCreditModal extends Component {
  @service constants;
  @service('commands/company-credit-commands') companyCreditCommandService;
  @service session;

  get className() {
    return CLASS_NAME;
  }

  get destinationCostCodeValue() {
    return this.args.model.destinationCostCode?.body ?? ' — ';
  }

  get costCodesSectionEnum() {
    return COMPANY_PROFILE_COMPONENT.SECTIONS.CODES;
  }

  get submitDisabled() {
    return this.addCredit.isRunning;
  }

  @dropTask
  *addCredit() {
    const {
      company,
      destinationCostCode,
      memo,
      paymentAmount,
      loadCompanyCostCodeCreditsTask,
      loadCreditUnpaidInvoicesTask,
      loadCompanyCreditFactoidsTask,
      updateCompanyCostCodeCredits,
      updateCompanyCreditFactoids,
      updateShGeneralUnpaidInvoices,
    } = this.args.model;

    const amountInCents = paymentAmount * 100;

    try {
      // perform add
      yield this.companyCreditCommandService.storeCompanyCredit({
        companyId: company.id,
        costCodeId: destinationCostCode.id,
        memo,
        amountInCents,
      });

      // reload all affected balances
      const [
        companyCostCodeCredits,
        creditUnpaidInvoices,
        companyCreditFactoids,
      ] = yield all([
        loadCompanyCostCodeCreditsTask.perform(),
        loadCreditUnpaidInvoicesTask.perform(),
        loadCompanyCreditFactoidsTask.perform(),
      ]);

      updateCompanyCreditFactoids(companyCreditFactoids);
      updateCompanyCostCodeCredits(
        companyCostCodeCredits.costCodes,
        companyCostCodeCredits.costCodesCurrentPage,
      );
      updateShGeneralUnpaidInvoices(
        creditUnpaidInvoices.shGeneralUnpaidInvoices,
        creditUnpaidInvoices.shGeneralUnpaidInvoicesPagination,
      );

      // show success
      showNextModal(this, 'confirmation', {
        classNames: `${CLASS_NAME}__success-modal`,
        titleText: 'Credit Pending',
        bodyText: 'New credit invoice generated and sent to your billing contact. Your credit will be available once the invoice is paid.<br>Until then, your credit will appear as "pending".',
        actionButtonText: 'Got it',
        width: 'medium',
        actionButtonLsgButtonType: BUTTON_TYPES.PRIMARY_REGULAR,
        iconComponentPath: CheckSweepIcon,
        isDismissible: false,
      });
    } catch (e) {
      handleErrorResponseWithModal(this, e);
    }
  }

  @action
  handleDestinationCostCodeSelected(costCode) {
    this.destinationCostCode = costCode;
  }

  @action
  handlePaymentAmountInput(amount) {
    this.paymentAmount = amount;
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default ReportsAddCreditModal;
